import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class GridHtmlComponent extends Vue {
    @Prop() public html: string;
}
